import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import EvaluatorService from '../../../Services/EvaluatorService';
import ForceEvaluatorUploadToTpInstanceItem from './ForceEvaluatorUploadToTpInstanceItem';

// Drives the GeneralEditWizzardBaseFigma wizard for the "Force Evaluator Upload
// to TP Instance" action. Single field -> compact centered DS modal. No
// entityName so the plain action title is used as the header.
export default class ForceEvaluatorUploadToTpInstanceWindowDescription {
  static titleForCreate = 'Force Evaluator Upload to TP Instance';
  static titleForEdit = 'Force Evaluator Upload to TP Instance';
  static itemType = ForceEvaluatorUploadToTpInstanceItem;
  static serviceFunction = EvaluatorService.PostForceEvaluatorUploadToTpInstance;
  static messageOnSuccess = 'Evaluator upload has been requested.';
  static finishButtonLabel = 'Save';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'TpInstanceId',
          label: 'Select a TP Instance',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: () => ForceEvaluatorUploadToTpInstanceWindowDescription.getSelectOptionsForTpInstances(),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];

  static getSelectOptionsForTpInstances() {
    return [
      { label: 'Choose one...', value: '', disabled: true },
      { label: 'RMX North Amerika', value: '3', disabled: false },
      { label: 'RMX Europe', value: '4', disabled: false },
      { label: 'RMX India', value: '5', disabled: false },
      { label: 'RMX LATAM', value: '6', disabled: false },
      { label: 'RMX Singapore', value: '7', disabled: false },
      { label: 'RMX Middle East', value: '8', disabled: false },
      { label: 'RMX Brazil', value: '9', disabled: false },
      { label: 'RMX China', value: '10', disabled: false },
    ];
  }
}
